import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { NightWorkDayBlock } from '../blocks/NightWorkDayBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const NightWorkDaysLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { nightWorkActivities } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {nightWorkActivities.map((item, index) => (
        <NightWorkDayBlock key={index} nightWorkActivity={item} />
      ))}
    </LayerWrapper>
  )
}

export default NightWorkDaysLayer
